import React, { useState, useEffect } from "react";
import styled, { keyframes, css } from "styled-components";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { graphql, useStaticQuery } from "gatsby";
import slugify from "slugify";
//assets
import logo from "assets/svg/logo.svg";
import OTOLogo from "assets/svg/OTO-logo.svg";
//styles
import colors from "styles/colors.js";
import typographySizes from "styles/typographySizes.js";
import distances from "styles/distances.js";
import mediaQuery from "styles/mediaQuery.js";

//components
import MainWrapper from "components/global/MainWrapper.js";
import Clock from "components/global/Clock.js";
import TextWithLineBreaks from "components/global/typography/TextWithLineBreaks.js";
import BoxBtn from "components/global/BoxBtn.js";
import Body from "components/global/typography/Body.js";

const Container = styled.footer`
  width: 100%;
  margin-top: 8rem;

 
  ${MainWrapper}{
    display: flex;
    flex-direction: column;
    gap: 16rem;
    @media (max-width: ${mediaQuery.laptop}) {

  gap: 4rem;
}
  }

`;

const TopWrapper = styled.div`
display: flex;
justify-content: space-between;
/* align-items: center; */

@media (max-width: ${mediaQuery.laptop}) {
  flex-direction: column;
  gap: 4rem;
}
`;

const TextWrapper = styled.div`
display: flex;
flex-direction: column;
gap: 2rem;
flex: 1;
`;

const Title = styled.h2`
font-size: ${typographySizes.text.tekstSize4.size.desktop}rem;
line-height: ${typographySizes.text.tekstSize4.lineHeight};
max-width: 45rem;
`;

const TeamWrapper = styled.div`
display: flex;
flex: 1;
@media (max-width: ${mediaQuery.tablet}) {
flex-direction: column;
gap: 2rem;
}

`;

const TeamItem = styled.div`
display: flex;
flex: 1;
flex-direction: column;
gap: 1rem;
`;

const TeamName = styled.h3`
font-size: ${typographySizes.text.tekstSize2.size.desktop}rem;
line-height: ${typographySizes.text.tekstSize2.lineHeight};
`;

const TeamDetails = styled.div`


`;

const TeamPosition = styled.p`
font-size: ${typographySizes.text.tekstSize2.size.desktop}rem;
line-height: ${typographySizes.text.tekstSize2.lineHeight};
`;

const TeamEmail = styled.a`
text-decoration: none;
font-size: ${typographySizes.text.tekstSize2.size.desktop}rem;
line-height: ${typographySizes.text.tekstSize2.lineHeight};
font-family: 'PPNikkeiPacific', sans-serif;


&:hover {
  background-color: ${colors.secondary};
  color: ${colors.main};
}
`;

const BottomWrapper = styled.div`
display: flex;
@media (max-width: ${mediaQuery.laptop}) {
  flex-direction: column;
  gap: 4rem;
}

`;

const ClocksContainer = styled.div`

flex: 1;
display: flex;
flex-direction: column;
justify-content: flex-end;
gap: 2rem;
`;

const ClocksWrapper = styled.div`
display: flex;
gap: 2rem;
@media (max-width: ${mediaQuery.laptop}) {
justify-content: space-between;

}
`;

const BottomInfo = styled.div`
flex: 1;
display: grid;
grid-template-columns: repeat(6, 1fr);

.bottom-info-text{

text-align: justify;
grid-column: 1 / 4;

grid-row: 1 / 2;
}

@media (max-width: ${mediaQuery.laptop}) {
  grid-template-columns: repeat(2, 1fr);

row-gap: 4rem;

.bottom-info-text{
  grid-column: 1 / 3;

grid-row: 1 / 2;
}

}

`;

const SocialMediaWrapper = styled.div`
display: flex;
flex-direction: column;

grid-column: 5 / 7;
grid-row: 1 / 2;
@media (max-width: ${mediaQuery.laptop}) {
  grid-column: 1 / 2;

grid-row: 2 / 3;
}
`;

const SocialMediaItem = styled.div`
display: flex;
gap: 1rem;
`;

const SocialMediaLink = styled.a`
text-decoration: none;
font-family: 'PPNikkeiPacific', sans-serif;
font-size: 1.4rem;
	line-height: 1;
&:hover {
  background-color: ${colors.secondary};
  color: ${colors.main};
}
`;

const Logo = styled.img`
align-self: end;

grid-column: 1 / 2;
grid-row: 2 / 3;

@media (max-width: ${mediaQuery.laptop}) {
  grid-column: 1 / 2;
  grid-row: 3 / 4;

}
`;

const LegalLinksWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  align-self: end;
grid-column: 3 / 7;
grid-row: 2 / 3;
@media (max-width: ${mediaQuery.laptop}) {
  grid-column: 2 / 3;
  grid-row: 2 / 3;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  align-self: flex-start;
}
`;

const LegalLink = styled.a`
text-decoration: none;
font-family: 'PPNikkeiPacific', sans-serif;
font-size: 1.4rem;
line-height: 1;

/* width: 100%; */
&:hover {
  background-color: ${colors.secondary};
  color: ${colors.main};
}
`;

const We3StudioLink = styled.a`
text-decoration: none;
font-family: 'PPNikkeiPacific', sans-serif;
font-size: 1.4rem;
line-height: 1;
text-align: right;

display: inline-block;
align-self: flex-end;
&:hover {
  background-color: ${colors.secondary};
  color: ${colors.main};
}
`;

const OttoWrapper = styled.a`
margin-top: 2rem;
  width: 100%;
  height: 3.2rem;
  position: relative;
  display: block;
background-color: ${colors.dark};
  div {
    width: 100%;
    height: 3.2rem;
    position: absolute !important;
    left: 0;
    top: 0;
  }
  img {
    position: absolute !important;
    width: 19.6rem;
    height: 1.7rem;
    object-fit: cover !important;
        left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }


  @media (max-width: ${mediaQuery.tablet}) {
margin-bottom: 2.1rem;
  }
`;

const Footer = ({ locale, langLink }) => {
  const data = useStaticQuery(graphql`
    query {
      allStrapiFooter {
        edges {
          node {
            locale
            Title
            Text
            Contact_button_label
            Contact_button_email
            Content_team {
              Name
              Position
              Email
            }
            Social_media {
              Name
              Link
            }
                 text_pages {
      Title
    }
            locale
          }
        }
      }
    }
  `);
  const footer =
    data.allStrapiFooter.edges
      .map(({ node }) => node)
      .find((node) => node.locale === locale) || null;
  return (
    <Container id="footer">
      <MainWrapper>
        {console.log(footer)}
        <TopWrapper>
          <TextWrapper>
            <Title>
              {" "}
              <TextWithLineBreaks text={footer?.Title} />
            </Title>
            <BoxBtn href={`mailto:${footer?.Contact_button_email}`}>
              {footer?.Contact_button_label}
            </BoxBtn>
          </TextWrapper>
          <TeamWrapper>
            {footer?.Content_team.map((item) => (
              <TeamItem key={item.Name}>
                <TeamName>{item.Name}</TeamName>
                <TeamDetails>
                  <TeamPosition>{item.Position}</TeamPosition>
                  <TeamEmail href={`mailto:${item.Email}`}>
                    {item.Email}
                  </TeamEmail>
                </TeamDetails>
              </TeamItem>
            ))}
          </TeamWrapper>
        </TopWrapper>
        <BottomWrapper>
          <BottomInfo>
            <Body className="bottom-info-text">{footer?.Text}</Body>
            <SocialMediaWrapper>
              {footer?.Social_media.map((item) => (
                <SocialMediaItem key={item.Name}>
                  <SocialMediaLink href={item.Link}>
                    {item.Name}
                  </SocialMediaLink>
                </SocialMediaItem>
              ))}
            </SocialMediaWrapper>
            <Logo src={logo} alt="Logo" />
            <LegalLinksWrapper>
              {footer?.text_pages.map((item) => {
                const slug = slugify(item.Title, { lower: true, strict: true });
                const url = locale === "en" ? `/${slug}` : `/pl/${slug}`;
                return (
                  <LegalLink key={item.Title} href={url}>
                    {item.Title}
                  </LegalLink>
                );
              })}
            </LegalLinksWrapper>
          </BottomInfo>
          <ClocksContainer>
            <ClocksWrapper>
              <Clock timeZone="Europe/Warsaw" city="WWA" />
              <Clock timeZone="Europe/London" city="LDN" />
              <Clock timeZone="America/New_York" city="NYC" />
            </ClocksWrapper>
            <We3StudioLink
              href="https://we3studio.pl/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              well designed by: we3studio.pl
            </We3StudioLink>
          </ClocksContainer>
        </BottomWrapper>
      </MainWrapper>
      <OttoWrapper href="https://otofamily.com/" target="_blank">
        <img src={OTOLogo} alt="OTO logo" />
      </OttoWrapper>
    </Container>
  );
};

export default Footer;
